import { forwardRef } from "react";
import { Form } from "ui";
import BamboraModel from "./types/BamboraModel";
import FormRef from "../types/FormRef";

type BamboraUpdateFormProps = {
    data: BamboraModel;
    errors: any;
    loading: boolean;
    onSubmit: (data: BamboraModel) => void;
};

const BamboraUpdateForm = forwardRef<FormRef, BamboraUpdateFormProps>(
    ({ data, errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={data}
                errors={errors}
                fields={{
                    environment: { default: "production" },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                Nothing to configure
            </Form>
        );
    },
);

export default BamboraUpdateForm;
